module.exports = __webpack_public_path__ + "static/media/success.1b4124de.svg";